import { useTranslation } from "react-i18next";
import type { AnalyticsSnapshotResponse } from "@/features/admin/adminAnalytics.types";
import {
  MetricBarChart,
  MetricLineChart,
} from "@/features/admin/components/analytics/MetricCharts";

type MetricPanel = {
  chart: "bar" | "line";
  metricKey: string;
  series: string[];
  title: string;
};

type GenericAnalyticsTabProps = {
  loading?: boolean;
  panels: MetricPanel[];
  snapshot: AnalyticsSnapshotResponse | null;
};

export function GenericAnalyticsTab({ loading, panels, snapshot }: GenericAnalyticsTabProps) {
  const { t } = useTranslation();

  return (
    <div className="grid gap-4 xl:grid-cols-2">
      {panels.map((panel) => {
        const Chart = panel.chart === "line" ? MetricLineChart : MetricBarChart;
        return (
          <section key={panel.metricKey} className="rounded-[1.45rem] border border-white/10 bg-black/20 p-4">
            <h3 className="text-sm font-semibold text-[#fff7ef]">{panel.title}</h3>
            <div className="mt-4">
              <Chart
                data={snapshot?.series[panel.metricKey] ?? []}
                emptyMessage={t("adminWorkspace.analytics.empty")}
                loading={loading}
                series={panel.series}
              />
            </div>
          </section>
        );
      })}
    </div>
  );
}
